<template>
    <div :class="['header',(detailsIsOpen)?'absolute':'']">
        <div class="header-wrapper">
            <div class="img-wrapper">
                <img class="header-laptop" :src="`/brands/${brand}/img/header-laptop.png`" alt="">
            </div>
            <div class="details-wrapper">
                <div class="details-content">
                    <h2>Your Browser's privacy</h2>
                    <a href="#" :class="['btn','btn-md','details-btn',(detailsIsOpen)?'showed':'']"
                       @click.prevent="toggleDetails">
                        <span class="details-text">{{(detailsIsOpen)?'Show less':'Details'}}</span>
                        <span class="corner-arrow"></span>
                    </a>
                    <div class="data-details" :style="[detailsIsOpen?{'display':'block'}:'']">
                        <table class="details-table">
                            <tbody>
                            <tr>
                                <td class="col-key">{{userAgent.browser.name}} version</td>
                                <td class="col-value">
                                    <span data-browser="">{{userAgent.browser.version}}</span>
                                </td>
                                <td>
                                    <i class="fas fa-check"></i>
                                    <span class="update-text">Up to date</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="col-key">OS version</td>
                                <td class="col-value">
                                    <span data-os="">{{userAgent.os.name}} {{userAgent.os.version}}</span>
                                </td>
                                <td>
                                    <i class="fas fa-check"></i>
                                    <span class="update-text">Up to date</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="col-key">Safe Browsing</td>
                                <td class="col-value">
                                    <div v-if="isInstalledByType('safe')">
                                        <span></span>Add-on
                                    </div>
                                    <div v-else>
                                        <i class="fas fa-exclamation-circle"></i>
                                        <span>Missing</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="isInstalledByType('safe')">
                                        <i class="fas fa-check"></i>
                                        <span class="update-text">Up to date</span>
                                    </div>
                                    <div v-else>
                                        <a href="#" @click.prevent="installExtension('safe')" class="btn btn-reverse">
                                            <i class="fas fa-plus icon"></i>Add to Chrome
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="col-key">Data Manager</td>
                                <td class="col-value">
                                    <div v-if="isInstalledByType('data')">
                                        <span data-privacy-version=""></span>Add-on
                                    </div>
                                    <div v-else>
                                        <i class="fas fa-exclamation-circle"></i>
                                        <span>Missing</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="isInstalledByType('data')">
                                        <i class="fas fa-check"></i>
                                        <span class="update-text">Up to date</span>
                                    </div>
                                    <div v-else>
                                        <a href="#" @click.prevent="installExtension('data')" class="btn btn-reverse">
                                            <i class="fas fa-plus icon"></i>Add to Chrome
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            <tr data-private-installed="">
                                <td class="col-key">Private Browsing</td>
                                <td class="col-value">
                                    <div v-if="isInstalledByType('private')">Add-on</div>
                                    <div v-else>
                                        <i class="fas fa-exclamation-circle"></i>
                                        <span>Missing</span>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="isInstalledByType('private')">
                                        <i class="fas fa-check"></i>
                                        <span class="update-text">Up to date</span>
                                    </div>
                                    <div v-else>
                                        <a href="#" @click.prevent="installExtension('private')" class="btn btn-reverse">
                                            <i class="fas fa-plus icon"></i>Add to Chrome
                                        </a>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="more-info-question-wrapper" id="question-char">
                    <div class="question-char">
                        <span>?</span>
                    </div>
                    <div class="question-tooltip">
                        <p>
                            This is your control panel page. In here you can get general information
                            about your browser, manage settings, get alerted on new available
                            Chrome
                            versions and recieve important updates. To get back to this screen,
                            click on
                            the <span class="brand-value">SAFELY</span> logo. <br>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Main",
        props: ['brand', 'userAgent'],
        data: function () {
            return {
                detailsIsOpen: false,
            }
        },
        methods: {
            toggleDetails: function () {
                this.detailsIsOpen = !this.detailsIsOpen;
            },
            isInstalledByType: function (type) {
                return this.$parent.isInstalledByType(type);
            },
            installExtension: function (extensionsType) {
                return this.$parent.installExtension(extensionsType);
            }
        }
    }
</script>

<style scoped>
    .header.absolute {
        z-index: 2;
        position: absolute;
        opacity: .9;
    }

    .header-wrapper {
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        transition: all .5s;
    }

    .header .img-wrapper {
        width: 280px;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        position: relative;
    }

    .header .img-wrapper img {
        width: 175px;
    }

    .header .details-content {
        display: inline-block;
        vertical-align: top;
        max-width: calc(100% - 60px);
    }

    .header .details-wrapper {
        width: calc(100% - 280px);
        display: inline-block;
        vertical-align: top;
        padding-left: 40px;
        position: relative;
    }

    .header .details-wrapper h2 {
        font-size: 30px;
        text-transform: uppercase;
        color: #fff;
        margin-bottom: 20px;
    }

    .details-table {
        margin-bottom: 10px;
    }

    .data-details {
        font-size: 16px;
        color: #fff;
        display: none;
    }

    .data-details .icon {
        font-size: 18px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
    }

    .data-details .update-text {
        margin: 0 10px;
    }

    .data-details td {
        padding: 10px 5px;
        line-height: 1;
        width: 200px;
        border-bottom: 1px solid #D3D3D3;
    }

    .details-table .col-value {
        font-weight: bold;
    }

    .details-table .col-key {
        width: 165px;
    }

    .btn.btn-reverse {
        background: #696969;
        color: #D3D3D3;
    }

    .btn.btn-reverse:hover {
        color: #696969;
        border-color: #696969;
        background-color: #D3D3D3;
    }

    i.fas.fa-exclamation-circle{
      padding: 12px;
    }

    i.fas.fa-plus.icon {
        padding-bottom: 3px;
    }

    /*
    *****************************
        btn safely
    *****************************
    */
    .safely .data-details td {
        border-bottom: 1px solid #0184C1;
    }

    .safely .btn.details-btn {
        background-color: #03a9f4;
    }

    .safely .btn.details-btn:hover {
        color: #03a9f4;
        border-color: #03a9f4;
        background-color: #fff;
    }

    .safely .btn.details-btn:hover .corner-arrow {
        border-color: #03a9f4;
    }

    .safely .btn.btn-reverse {
        background: #fff;
        color: #03a9f4;
    }

    .safely .btn.btn-reverse:hover {
        color: #fff;
        border-color: #fff;
        background-color: #03a9f4;
    }

    /*
    *****************************
        privately
    *****************************
    */

    .privately .btn.details-btn {
        border: 2px solid #fff;
        color: #fff;
        background: transparent;
        padding: 6px 12px;
    }

    .privately .btn.details-btn:hover {
        color: #00cdad;
        background: #fff;
        border-color: #fff;
    }

    .privately .header .img-wrapper {
        width: 120px;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        position: relative;
        padding-top: 5px;
    }

    .privately .header .img-wrapper img {
        width: auto;
    }

    .privately .header .details-wrapper {
        width: calc(100% - 120px);
    }

    .privately .data-details td {
        padding: 7px;
        border-bottom: none;
    }


    /*
   *****************************
       online-tools
   *****************************
   */

    .onlinetools .details-table .col-value {
        font-weight: bold;
        color:#3C557E;
    }

    .onlinetools .details-table .col-key {
        width: 165px;
        color:#3C557E;
    }

    .onlinetools .data-details .update-text{
        color:#3C557E;
        font-weight: 600;
    }

    .onlinetools .fa-check::before{
        color: #8BD8BD;
    }

</style>